import loadable from '@loadable/component';

export const AsyncAppLayout = loadable(() => import('components/Layout/AppLayout'));
export const AsyncAppStaticLayout = loadable(() =>
  import('components/Layout/AppLayout/ContentOnly')
);
export const AsyncQrReceipt = loadable(() => import('containers/Exception/QrReceipt'));
export const AsyncNewQrReceipt = loadable(() =>
  import('containers/Exception/NewQrReceiptContainer')
);
export const AsyncLoginForm = loadable(() => import('containers/Auth/LoginContainer'));
export const AsyncOTPForm = loadable(() => import('containers/Auth/OTPContainer'));
export const AsyncResetForm = loadable(() => import('containers/Auth/ResetContainer'));
export const AsyncInternalServer = loadable(() =>
  import('containers/Exception/InternalServerContainer')
);
export const AsyncNotFound = loadable(() => import('containers/Exception/NotFoundContainer'));
export const AsyncForbidden = loadable(() => import('containers/Exception/ForbiddenContainer'));
export const AsyncDashboard = loadable(() => import('containers/Dashboard/'));
export const AsyncBillingSystem = loadable(() => import('containers/Billing'));
export const AsyncProfile = loadable(() => import('containers/Profile/'));
export const AsyncRole = loadable(() => import('containers/Role/'));
export const AsyncDepartment = loadable(() => import('containers/Department/'));
export const AsyncBranch = loadable(() => import('containers/Branch/'));
export const AsyncSwitch = loadable(() => import('containers/Switch/'));
export const AsyncUser = loadable(() => import('containers/User/'));
export const AsyncOperator = loadable(() => import('containers/Operator/'));
export const AsyncTerminal = loadable(() => import('containers/Terminal'));
export const AsyncTransaction = loadable(() => import('containers/Transaction/'));
export const AsyncActivityLog = loadable(() => import('containers/ActivityLog/'));
export const AsyncAuditLog = loadable(() => import('containers/AuditLog/'));
export const AsyncTransactionRule = loadable(() => import('containers/TransactionRule/'));
export const AsyncUtility = loadable(() => import('containers/Utility/'));
export const AsyncInquiry = loadable(() => import('containers/Inquiry/'));
export const AsyncRequest = loadable(() => import('containers/Request/'));
export const AsyncCustomer = loadable(() => import('containers/Customer/'));
export const AsyncApp = loadable(() => import('containers/Apps/'));
export const AsyncSetting = loadable(() => import('containers/Setting/'));
export const AsyncMTO = loadable(() => import('containers/MTO/'));
export const AsyncChannel = loadable(() => import('containers/Channel/'));
export const AsyncCompliance = loadable(() => import('containers/Compliance/'));
export const AsyncEMITransaction = loadable(() => import('containers/EMITransaction/'));
export const AsyncSettlement = loadable(() => import('containers/Settlement/'));
export const AsyncNotification = loadable(() => import('containers/Notification'));
export const AsyncUploadTransaction = loadable(() => import('containers/UploadTransaction/'));
export const AsyncQrProvider = loadable(() => import('containers/QRProvider/'));
export const AsyncSupport = loadable(() => import('containers/Support/'));
export const AsyncMerchantAutoOnboard = loadable(() => import('containers/getpay'));
